import type { QueryClient } from '@tanstack/react-query';

/** Simple client-side holder so non-React modules (e.g. apiFetch) can
 *  access the shared QueryClient instance and invalidate queries.
 * */
let queryClientRef: QueryClient | undefined;

export const setQueryClient = (client: QueryClient) => {
  queryClientRef = client;
};

export const getQueryClient = () => queryClientRef;
